import { Component, Renderer2, ElementRef, AfterViewInit } from '@angular/core';
import { StaticFileService } from '../static-file.service';
import * as basicScroll from 'basicscroll';

@Component({
  selector: 'app-banner-painting',
  templateUrl: './banner-painting.component.html',
  styleUrls: ['./banner-painting.component.css']
})
export class BannerPaintingComponent implements AfterViewInit {

  constructor(public staticFileService: StaticFileService, private renderer: Renderer2, private elem: ElementRef) { }

  ngAfterViewInit() {
    this.initParallax();
  }

  private initParallax() {
    const layers = this.elem.nativeElement.querySelectorAll('.banner-painting-layer');
    layers.forEach(layer => {
      const mod = layer.getAttribute('data-modifier');
      basicScroll.create({
        elem: layer,
          from: 0,
          to: 500,
          direct: true,
          props: {
              '--translateY': {
                  from: '0',
                  to: (10 * mod) + 'px'
              }
          }
      }).start();
    });
  }

}
